<template>
	<li class="hoverBg by-bg-white">
		<div class="pic picList">
			<img :src="itemData.coverUrl" alt="" />
		</div>
		<div class="homeCyqyCont">
				<h2>{{itemData.name}}</h2>
			<p class="price">￥{{itemData.minPrice / 100}}</p>
			<div class="buyBtn" href="#" @click="qrCode">
				<i class="gxyf-iconfont icon-che1 mr-5"></i>
				点击购买
			</div>
		</div>
		
	</li>
</template>

<script>
/**
 * 描述
 * @description 描述
 * @property {String}
 * @example <aby-botton-line  />
 */

export default {
	props: {
			itemData:[Object,String,Array,Number]
	},
	data() {
		return {
				
		};
	},
	computed: {},
	created(obj) {
		// 页面第一次加载执行，参数为上个页面传递的数据，参数类型为Object
	},
	methods: {
		qrCode(){
			this.$emit('tipShow')
		}
	},
	watch: {
		obj: {
			//监听的对象
			deep: true, //深度监听设置为 true
			handler: function(newV, oldV) {
				console.log('watch中：', newV);
			}
		}
	}
};
</script>

<style scoped>
.buyBtn{
	cursor: pointer;
}

.picList > img {
	width: 100%;
	height: 210px;
	object-fit:fill;
}
.gxyf-iconfont{
	user-select: none;
}
</style>
